import React from 'react';

import logo from '../assets/img/logo.svg';
import '../assets/css/header.css';

const Header = () =>
  <header>
    <img src={logo} alt="" />
  </header>;

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.jsx